(function (e, s, i) {
    "use strict";
    i(s).ready(function () {
        function a(e, s) {
            e.children(".submenu-content").show().slideUp(200, function () {
                i(this).css("display", "");
                i(this).find(".menu-item").removeClass("is-shown");
                e.removeClass("open");
                s && s();
            });
        }

        var n = i(".app-sidebar"),
            t = i(".sidebar-content"),
            l = i(".wrapper"),
            $window = i(e),
            $document = i(s);

        function handleResize() {
            if ($window.width() < 992) {
                n.addClass("hide-sidebar");
                l.removeClass("nav-collapsed menu-collapsed");
            } else {
                n.removeClass("hide-sidebar");
                if (i(".toggle-icon").attr("data-toggle") === "collapsed") {
                    l.addClass("nav-collapsed menu-collapsed");
                }
            }
        }

        var debounce = function (func, wait) {
            var timeout;
            return function () {
                var context = this, args = arguments;
                clearTimeout(timeout);
                timeout = setTimeout(function () {
                    func.apply(context, args);
                }, wait);
            };
        };

        var sidebarState = localStorage.getItem('sidebarState') || 'expanded';
        if (sidebarState === 'collapsed') {
            l.addClass("nav-collapsed");
            i(".nav-toggle").find(".toggle-icon").removeClass("ik-toggle-right").addClass("ik-toggle-left");
            i(".nav-toggle").find(".toggle-icon").attr("data-toggle", "collapsed");
        }else {
            l.removeClass("nav-collapsed menu-collapsed");
            i(".nav-toggle").find(".toggle-icon").removeClass("ik-toggle-left").addClass("ik-toggle-right");
            i(".nav-toggle").find(".toggle-icon").attr("data-toggle", "expanded");
        }
        i(".nav-toggle").on("click", function () {
            var e = i(this).find(".toggle-icon");
            if (e.attr("data-toggle") === "expanded") {
                l.addClass("nav-collapsed");
                i(".nav-toggle").find(".toggle-icon").removeClass("ik-toggle-right").addClass("ik-toggle-left");
                e.attr("data-toggle", "collapsed");

                localStorage.setItem('sidebarState', 'collapsed');
            } else {
                l.removeClass("nav-collapsed menu-collapsed");
                i(".nav-toggle").find(".toggle-icon").removeClass("ik-toggle-left").addClass("ik-toggle-right");
                e.attr("data-toggle", "expanded");

                localStorage.setItem('sidebarState', 'expanded');
            }
        });

        n.on("mouseenter", function () {
            if (l.hasClass("nav-collapsed")) {
                l.removeClass("menu-collapsed");
                var e = i(".navigation-main .nav-item.nav-collapsed-open");
                e.children(".submenu-content").hide().slideDown(300, function () {
                    i(this).css("display", "");
                });
                t.find(".nav-item.active").parents(".nav-item").addClass("open");
                e.addClass("open").removeClass("nav-collapsed-open");
            }
        }).on("mouseleave", function () {
            if (l.hasClass("nav-collapsed")) {
                l.addClass("menu-collapsed");
                var s = i(".navigation-main .nav-item.open"),
                    a = s.children(".submenu-content");
                s.addClass("nav-collapsed-open");
                a.show().slideUp(300, function () {
                    i(this).css("display", "");
                });
                s.removeClass("open");
            }
        });

        handleResize();
        $window.resize(debounce(handleResize, 200));

        $document.on("click", ".navigation li:not(.has-sub), .logo-text", function () {
            if ($window.width() < 992) {
                n.addClass("hide-sidebar");
            }
        });

        i(".mobile-nav-toggle").on("click", function (e) {
            e.stopPropagation();
            n.toggleClass("hide-sidebar");
        });

        i("html").on("click", function (s) {
            if ($window.width() < 992 && !n.hasClass("hide-sidebar") && n.has(s.target).length === 0) {
                n.addClass("hide-sidebar");
            }
        });

        i("#sidebarClose").on("click", function () {
            n.addClass("hide-sidebar");
        });

        i('[data-toggle="tooltip"]').tooltip();

        i("#checkbox_select_all").on("click", function () {
            var checkboxes = s.getElementsByName("item_checkbox");
            for (var a = 0; a < checkboxes.length; a++) {
                if (checkboxes[a].type === "checkbox") {
                    checkboxes[a].checked = true;
                }
            }
            i(checkboxes).parent().parent().addClass("selected");
        });

        i("#checkbox_deselect_all").on("click", function () {
            var checkboxes = s.getElementsByName("item_checkbox");
            for (var a = 0; a < checkboxes.length; a++) {
                if (checkboxes[a].type === "checkbox") {
                    checkboxes[a].checked = false;
                }
            }
            i(checkboxes).parent().parent().removeClass("selected");
        });

        i("#quick-search").keyup(function () {
            var e = i(this).val().trim().toLowerCase();
            i(".app-item").hide().filter(function () {
                return i(this).html().trim().toLowerCase().indexOf(e) !== -1;
            }).show();
        });

        i(".list-item input:checkbox").change(function () {
            i(this).is(":checked") ? i(this).parent().parent().addClass("selected") : i(this).parent().parent().removeClass("selected");
        });

        i("#navbar-fullscreen").on("click", function () {
            if (typeof screenfull !== "undefined" && screenfull.enabled) {
                screenfull.toggle();
            }
        });

        i("#selectall").click(function () {
            i(".select_all_child:checkbox").prop("checked", i(this).is(":checked"));
        });

        i(".list-item-wrap .list-item .list-title a").on("click", function () {
            i(".list-item.quick-view-opened").not(this).removeClass("quick-view-opened");
            i(this).parents().parent(".list-item").toggleClass("quick-view-opened");
        });

        $document.on("click", function (e) {
            if (!i(e.target).closest(".list-item").length) {
                i(".list-item").removeClass("quick-view-opened");
            }
        });

        if (typeof screenfull !== "undefined" && screenfull.enabled) {
            $document.on(screenfull.raw.fullscreenchange, function () {
                i("#navbar-fullscreen").find("i").toggleClass("ik-minimize ik-maximize", screenfull.isFullscreen);
            });
        }

        i(".minimize-widget").on("click", function () {
            var e = i(this),
                s = i(e.parents(".widget"));
            s.children(".widget-body").slideToggle();
            e.toggleClass("ik-minus ik-plus").fadeIn("slow");
        });

        i(".remove-widget").on("click", function () {
            var e = i(this);
            e.parents(".widget").animate({
                opacity: "0",
                "-webkit-transform": "scale3d(.3, .3, .3)",
                transform: "scale3d(.3, .3, .3)"
            });
            setTimeout(function () {
                e.parents(".widget").remove();
            }, 800);
        });

        i(".card-header-right .card-option .action-toggle").on("click", function () {
            var e = i(this);
            e.parents(".card-option").animate({
                width: e.hasClass("ik-chevron-right") ? "28px" : "90px"
            });
            e.toggleClass("ik-chevron-right").fadeIn("slow");
        });

        i(".card-header-right .close-card").on("click", function () {
            var e = i(this);
            e.parents(".card").animate({
                opacity: "0",
                "-webkit-transform": "scale3d(.3, .3, .3)",
                transform: "scale3d(.3, .3, .3)"
            });
            setTimeout(function () {
                e.parents(".card").remove();
            }, 800);
        });

        i(".card-header-right .minimize-card").on("click", function () {
            var e = i(this),
                s = i(e.parents(".card"));
            s.children(".card-body").slideToggle();
            e.toggleClass("ik-minus ik-plus").fadeIn("slow");
        });

        i(".task-list").on("click", "li.list", function () {
            i(this).toggleClass("completed");
        });

        i(".search-btn").on('click', function () {
            i(".header-search").addClass('open');
            i('.header-search .form-control').animate({
                'width': '200px'
            });
        });

        i(".search-close").on('click', function () {
            i('.header-search .form-control').animate({
                'width': '0'
            });
            setTimeout(function () {
                i(".header-search").removeClass('open');
            }, 300);
        });

        $(".right-sidebar-toggle").on("click", function () {
            this.classList.toggle('active');
            $('.wrapper').toggleClass('right-sidebar-expand');
            return false;
        });

        document.addEventListener('click', function (event) {
            var $rightSidebar = document.getElementsByClassName('right-sidebar')[0],
                $chatPanel = document.getElementsByClassName('chat-panel')[0];
            var isInsideContainer = ($rightSidebar && $rightSidebar.contains(event.target)) || ($chatPanel && $chatPanel.contains(event.target));
            if (!isInsideContainer) {
                document.body.classList.remove('right-sidebar-expand');
                var toggle = document.getElementsByClassName('right-sidebar-toggle');
                for (var i = 0; i < toggle.length; i++) {
                    toggle[i].classList.remove('active');
                }
                if ($chatPanel) $chatPanel.hidden = 'hidden';
            }
        });

        var gridButton = $('a.view-grid'),
            thumbButton = $('a.view-thumb'),
            listButton = $('a.view-list'),
            items = $('ul.view-as'),
            displayButtons = $('.dispaly-option-buttons a');

        gridButton.click(function () {
            $('#layout-wrap .list-item').attr('class', 'col-xl-3 col-lg-4 col-12 col-sm-6 mb-4 list-item list-item-grid');
        });

        listButton.click(function () {
            $('#layout-wrap .list-item').attr('class', 'col-12 list-item');
        });

        thumbButton.click(function () {
            $('#layout-wrap .list-item').attr('class', 'col-12 list-item list-item-thumb');
        });

        $(displayButtons).on('click', function () {
            $(displayButtons).removeClass('active');
            $(this).addClass('active');
        });
    });
}(window, document, jQuery));